module.exports = __webpack_public_path__ + "static/media/Separator_AI.3a50cc60.svg";